<app-offline-indicator />

<div class="block min-h-screen font-sans text-base font-normal">
  @if (isLoading()) {
    <div class="flex h-screen items-center justify-center">
      <app-loading></app-loading>
    </div>
  }

  <app-toast />
  <app-leave-confirm />

  @if (showInAppBrowserError()) {
    <app-browser-empty-state></app-browser-empty-state>
  } @else {
    <div class="block" [ngClass]="{ hidden: this.isLoading() }">
      <router-outlet></router-outlet>
    </div>
  }
</div>

@if (showRedirectModal()) {
  <app-redirect-modal></app-redirect-modal>
}
